// extracted by css-extract-rspack-plugin
var _1 = "YOxsYRdMKWGqkNtU9DcQdg--";
var _2 = "JegcckozpiigqEKlQD8eaQ--";
var _3 = "RJyTxXI1j8ZviAO25Oj18w--";
export { _1 as "content", _2 as "heading", _3 as "subHeading" }
